export default "__VITE_ASSET__42d3a6fe__$_?component__"